import { __extends } from 'tslib';
import { Injectable, Component, NgModule } from '@angular/core';
import { of, Subject } from 'rxjs';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { first, map } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { LocalStorageService } from 'angular-2-local-storage';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @param {?} object
 * @return {?}
 */
function componentHasGuidedTour(object) {
    return 'getTour' in object;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var  /**
 * @abstract
 */
TourStep = /** @class */ (function () {
    function TourStep() {
    }
    return TourStep;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Tour step that highlights an element on the page with some explanation
 */
var  /**
 * Tour step that highlights an element on the page with some explanation
 */
ElementTourStep = /** @class */ (function (_super) {
    __extends(ElementTourStep, _super);
    function ElementTourStep(selector, body, async) {
        var _this = _super.call(this) || this;
        _this.domElement = window.document.querySelector(selector);
        if (!(_this.domElement instanceof Element)) {
            if (async) {
                /** @type {?} */
                var timeout_1 = 100;
                /** @type {?} */
                var retry = function () {
                    // Give up eventually
                    if (timeout_1 <= 2000) {
                        _this.domElement = window.document.querySelector(selector);
                        if (!(_this.domElement instanceof Element)) {
                            timeout_1 *= 2;
                            setTimeout(retry, timeout_1);
                        }
                    }
                };
                setTimeout(retry, timeout_1);
            }
            else {
                throw new Error("Couldn't find the element you selected");
            }
        }
        _this.body = body;
        return _this;
    }
    Object.defineProperty(ElementTourStep.prototype, "top", {
        //region DOM position helpers
        get: /**
         * @return {?}
         */
        function () {
            if (!this.domElement) {
                return '0';
            }
            return (this.domElement.getBoundingClientRect().top + window.pageYOffset) + 'px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementTourStep.prototype, "bottom", {
        get: /**
         * @return {?}
         */
        function () {
            if (!this.domElement) {
                return '0';
            }
            return (this.domElement.getBoundingClientRect().bottom + window.pageYOffset) + 'px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementTourStep.prototype, "left", {
        get: /**
         * @return {?}
         */
        function () {
            if (!this.domElement) {
                return '0';
            }
            return (this.domElement.getBoundingClientRect().left + window.pageXOffset) + 'px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementTourStep.prototype, "right", {
        get: /**
         * @return {?}
         */
        function () {
            if (!this.domElement) {
                return '0';
            }
            return (this.domElement.getBoundingClientRect().right + window.pageXOffset) + 'px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementTourStep.prototype, "documentHeight", {
        get: /**
         * @return {?}
         */
        function () {
            return document.body.scrollHeight + 'px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementTourStep.prototype, "documentWidth", {
        get: /**
         * @return {?}
         */
        function () {
            return document.body.scrollWidth + 'px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementTourStep.prototype, "toBottom", {
        get: /**
         * @return {?}
         */
        function () {
            if (!this.domElement) {
                return '0';
            }
            return (document.body.scrollHeight - (this.domElement.getBoundingClientRect().bottom + window.pageYOffset)) + 'px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementTourStep.prototype, "toRight", {
        get: /**
         * @return {?}
         */
        function () {
            if (!this.domElement) {
                return '0';
            }
            return (document.body.scrollWidth - (this.domElement.getBoundingClientRect().right + window.pageXOffset)) + 'px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementTourStep.prototype, "fromLeft", {
        get: /**
         * @return {?}
         */
        function () {
            if (!this.domElement) {
                return '0';
            }
            return (document.body.scrollWidth - (this.domElement.getBoundingClientRect().left + window.pageXOffset)) + 'px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementTourStep.prototype, "fromTop", {
        get: /**
         * @return {?}
         */
        function () {
            if (!this.domElement) {
                return '0';
            }
            return (document.body.scrollHeight - (this.domElement.getBoundingClientRect().top + window.pageYOffset)) + 'px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementTourStep.prototype, "height", {
        get: /**
         * @return {?}
         */
        function () {
            if (!this.domElement) {
                return '0';
            }
            return this.domElement.getBoundingClientRect().height + 'px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementTourStep.prototype, "width", {
        get: /**
         * @return {?}
         */
        function () {
            if (!this.domElement) {
                return '0';
            }
            return this.domElement.getBoundingClientRect().width + 'px';
        },
        enumerable: true,
        configurable: true
    });
    return ElementTourStep;
}(TourStep));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TourPersistency = /** @class */ (function () {
    function TourPersistency() {
    }
    /**
     * Whether a tour should be started
     *
     * @param {?} componentName Name of the component that the user has arrived at
     * @return {?}
     */
    TourPersistency.prototype.shouldStart = /**
     * Whether a tour should be started
     *
     * @param {?} componentName Name of the component that the user has arrived at
     * @return {?}
     */
    function (componentName) {
        if (typeof window === 'undefined') {
            // If we are in a server-side render, never start
            return of(false);
        }
        if (window.screen.width <= 900) {
            return of(false);
        }
        return of(true);
    };
    /**
     * Finish the tour for a component
     * @param {?} componentName
     * @return {?}
     */
    TourPersistency.prototype.finish = /**
     * Finish the tour for a component
     * @param {?} componentName
     * @return {?}
     */
    function (componentName) { };
    /**
     * Skip the tour for a component
     * @param {?} componentName
     * @return {?}
     */
    TourPersistency.prototype.skip = /**
     * Skip the tour for a component
     * @param {?} componentName
     * @return {?}
     */
    function (componentName) { };
    TourPersistency.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    TourPersistency.ctorParameters = function () { return []; };
    return TourPersistency;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TelemachyService = /** @class */ (function () {
    function TelemachyService(Router$$1, ActivatedRoute$$1, TourPersistency$$1) {
        var _this = this;
        this.TourPersistency = TourPersistency$$1;
        this.recurseRouteTree = function (state) {
            // TODO: Find all, only trigger when it is new
            if (state.component) {
                /** @type {?} */
                var c = (/** @type {?} */ (state.component)).prototype;
                if (componentHasGuidedTour(c) && c.tourAutoStart && c.tourAutoStart()) {
                    _this.seenComponent = c;
                    _this.startTour(c);
                }
            }
            state.children.forEach(_this.recurseRouteTree);
        };
        this.activeStep = -1;
        this.startEventListener = [];
        this.endEventListener = [];
        Router$$1.events.subscribe(function (e) {
            if (e instanceof NavigationEnd) {
                _this.seenComponent = null;
                _this.recurseRouteTree(ActivatedRoute$$1.snapshot);
            }
        });
        this.currentTourStep = new Subject();
    }
    /**
     * @param {?} component
     * @return {?}
     */
    TelemachyService.prototype.startTourForComponent = /**
     * @param {?} component
     * @return {?}
     */
    function (component) {
        // Only start if we are not started
        if (this.activeStep < 0) {
            this.startEventListener.forEach(function (func) { return func(); });
            this.activeTour = component.getTour();
            this.activeStep = 0;
            this.activeComponent = component.constructor.name;
            this.emit();
        }
    };
    /**
     * Attempt to start the tour for a component
     * @param {?} component
     * @return {?}
     */
    TelemachyService.prototype.startTour = /**
     * Attempt to start the tour for a component
     * @param {?} component
     * @return {?}
     */
    function (component) {
        var _this = this;
        // Multiple components might want to get their tour started at the same time
        // We go with the first one that decides it should be loaded and ignore the rest
        this.TourPersistency.shouldStart(component.constructor.name).pipe(first()).subscribe(function (shouldStart) {
            if (shouldStart) {
                _this.startTourForComponent(component);
            }
        });
    };
    /**
     * Indicates if there is a tour that could be restarted
     * @return {?}
     */
    TelemachyService.prototype.canRestart = /**
     * Indicates if there is a tour that could be restarted
     * @return {?}
     */
    function () {
        return ((this.activeStep === -1) && (!!this.seenComponent));
    };
    /**
     * Restarts the tour for a component (no guarantee which) that is visible right now
     * @return {?}
     */
    TelemachyService.prototype.restartTour = /**
     * Restarts the tour for a component (no guarantee which) that is visible right now
     * @return {?}
     */
    function () {
        this.startTourForComponent(this.seenComponent);
    };
    /**
     * @return {?}
     */
    TelemachyService.prototype.canGoBack = /**
     * @return {?}
     */
    function () {
        return this.activeStep >= 1;
    };
    /**
     * @return {?}
     */
    TelemachyService.prototype.canFinish = /**
     * @return {?}
     */
    function () {
        if (!this.activeTour) {
            return false;
        }
        return this.activeStep === (this.activeTour.length - 1);
    };
    /**
     * @return {?}
     */
    TelemachyService.prototype.finish = /**
     * @return {?}
     */
    function () {
        if (this.canFinish()) {
            this.TourPersistency.finish(this.activeComponent);
            this.reset();
        }
    };
    /**
     * @return {?}
     */
    TelemachyService.prototype.skip = /**
     * @return {?}
     */
    function () {
        this.TourPersistency.skip(this.activeComponent);
        this.reset();
    };
    /**
     * @param {?} step
     * @return {?}
     */
    TelemachyService.prototype.scrollViewport = /**
     * @param {?} step
     * @return {?}
     */
    function (step) {
        /** @type {?} */
        var rightBound = (window.pageXOffset + window.innerWidth) - parseInt(step.right);
        /** @type {?} */
        var leftBound = parseInt(step.left) - window.pageXOffset;
        if (rightBound < 0) {
            window.scrollTo(parseInt(step.left), 0);
        }
        if (leftBound < 0) {
            window.scrollTo(parseInt(step.left), 0);
        }
    };
    /**
     * @return {?}
     */
    TelemachyService.prototype.next = /**
     * @return {?}
     */
    function () {
        if (this.activeStep < (this.activeTour.length - 1)) {
            this.activeStep += 1;
            // Workaround for broken elements, just skip ahead
            if (this.activeTour[this.activeStep] instanceof ElementTourStep && !(/** @type {?} */ (this.activeTour[this.activeStep])).domElement) {
                if (this.canFinish()) {
                    this.finish();
                }
                else {
                    this.next();
                }
            }
        }
        this.emit();
        /** @type {?} */
        var step = this.activeTour[this.activeStep];
        this.scrollViewport(step);
    };
    /**
     * @return {?}
     */
    TelemachyService.prototype.previous = /**
     * @return {?}
     */
    function () {
        if (this.canGoBack()) {
            this.activeStep -= 1;
            // Workaround for broken elements, just skip back or stay in the same position
            if (this.activeTour[this.activeStep] instanceof ElementTourStep && !(/** @type {?} */ (this.activeTour[this.activeStep])).domElement) {
                if (this.canGoBack()) {
                    this.previous();
                }
                else {
                    this.next();
                }
            }
        }
        this.emit();
        /** @type {?} */
        var step = this.activeTour[this.activeStep];
        this.scrollViewport(step);
    };
    /**
     * @return {?}
     */
    TelemachyService.prototype.reset = /**
     * @return {?}
     */
    function () {
        this.activeTour = null;
        this.activeStep = -1;
        this.activeComponent = null;
        this.emit();
        this.endEventListener.forEach(function (func) { return func(); });
    };
    /**
     * @return {?}
     */
    TelemachyService.prototype.emit = /**
     * @return {?}
     */
    function () {
        if (!this.activeTour) {
            this.currentTourStep.next(null);
        }
        else {
            this.currentTourStep.next(this.activeTour[this.activeStep]);
        }
    };
    /**
     * @param {?=} generatorOrNext
     * @param {?=} error
     * @param {?=} complete
     * @return {?}
     */
    TelemachyService.prototype.subscribeStep = /**
     * @param {?=} generatorOrNext
     * @param {?=} error
     * @param {?=} complete
     * @return {?}
     */
    function (generatorOrNext, error, complete) {
        return this.currentTourStep.subscribe(generatorOrNext, error, complete);
    };
    Object.defineProperty(TelemachyService.prototype, "progress", {
        get: /**
         * @return {?}
         */
        function () {
            return this.activeStep + 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TelemachyService.prototype, "total", {
        get: /**
         * @return {?}
         */
        function () {
            return this.activeTour.length;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Adds an event listener that is called at either the start or end of the tour.
     * Types are 'start' or 'end'
     * listener can't be an anonymous function else it is not possible to remove the callback.
     *
     * @param {?} type string
     * @param {?} listener function
     * @return {?}
     */
    TelemachyService.prototype.addEventListener = /**
     * Adds an event listener that is called at either the start or end of the tour.
     * Types are 'start' or 'end'
     * listener can't be an anonymous function else it is not possible to remove the callback.
     *
     * @param {?} type string
     * @param {?} listener function
     * @return {?}
     */
    function (type, listener) {
        if (type == 'start') {
            this.startEventListener.push(listener);
        }
        if (type == 'end') {
            this.endEventListener.push(listener);
        }
    };
    /**
     * Removes an event listener.
     * Types are 'start' or 'end'
     * listener should be the same function as the one that was added.
     *
     * @param {?} type string
     * @param {?} listener function
     * @return {?}
     */
    TelemachyService.prototype.removeEventListener = /**
     * Removes an event listener.
     * Types are 'start' or 'end'
     * listener should be the same function as the one that was added.
     *
     * @param {?} type string
     * @param {?} listener function
     * @return {?}
     */
    function (type, listener) {
        if (type == 'start') {
            /** @type {?} */
            var index = this.startEventListener.indexOf(listener);
            this.startEventListener.splice(index, 1);
        }
        if (type == 'end') {
            /** @type {?} */
            var index = this.endEventListener.indexOf(listener);
            this.endEventListener.splice(index, 1);
        }
    };
    TelemachyService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    TelemachyService.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: TourPersistency }
    ]; };
    return TelemachyService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Tour step that shows a Youtube video in the middle of the page
 */
var  /**
 * Tour step that shows a Youtube video in the middle of the page
 */
YoutubeTourStep = /** @class */ (function (_super) {
    __extends(YoutubeTourStep, _super);
    function YoutubeTourStep(video) {
        var _this = _super.call(this) || this;
        _this.video = video;
        return _this;
    }
    return YoutubeTourStep;
}(TourStep));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Tour step that shows some HTML in the middle of the page
 */
var  /**
 * Tour step that shows some HTML in the middle of the page
 */
HTMLTourStep = /** @class */ (function (_super) {
    __extends(HTMLTourStep, _super);
    function HTMLTourStep(body) {
        var _this = _super.call(this) || this;
        _this.body = body;
        return _this;
    }
    return HTMLTourStep;
}(TourStep));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TelemachyTourComponent = /** @class */ (function () {
    function TelemachyTourComponent(TelemachyService$$1, DomSanitizer$$1) {
        this.TelemachyService = TelemachyService$$1;
        this.DomSanitizer = DomSanitizer$$1;
    }
    /**
     * @return {?}
     */
    TelemachyTourComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.sub = this.TelemachyService.subscribeStep(function (step) {
            _this.step = step;
        });
    };
    /**
     * @return {?}
     */
    TelemachyTourComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.sub.unsubscribe();
    };
    /**
     * @return {?}
     */
    TelemachyTourComponent.prototype.canGoBack = /**
     * @return {?}
     */
    function () {
        return this.TelemachyService.canGoBack();
    };
    /**
     * @return {?}
     */
    TelemachyTourComponent.prototype.canFinish = /**
     * @return {?}
     */
    function () {
        return this.TelemachyService.canFinish();
    };
    /**
     * @return {?}
     */
    TelemachyTourComponent.prototype.finish = /**
     * @return {?}
     */
    function () {
        return this.TelemachyService.finish();
    };
    /**
     * @return {?}
     */
    TelemachyTourComponent.prototype.skip = /**
     * @return {?}
     */
    function () {
        return this.TelemachyService.skip();
    };
    /**
     * @return {?}
     */
    TelemachyTourComponent.prototype.next = /**
     * @return {?}
     */
    function () {
        return this.TelemachyService.next();
    };
    /**
     * @return {?}
     */
    TelemachyTourComponent.prototype.previous = /**
     * @return {?}
     */
    function () {
        return this.TelemachyService.previous();
    };
    /**
     * @param {?} step
     * @return {?}
     */
    TelemachyTourComponent.prototype.isYoutube = /**
     * @param {?} step
     * @return {?}
     */
    function (step) {
        return step instanceof YoutubeTourStep;
    };
    /**
     * @param {?} step
     * @return {?}
     */
    TelemachyTourComponent.prototype.isHtml = /**
     * @param {?} step
     * @return {?}
     */
    function (step) {
        return step instanceof HTMLTourStep;
    };
    /**
     * @param {?} step
     * @return {?}
     */
    TelemachyTourComponent.prototype.isElement = /**
     * @param {?} step
     * @return {?}
     */
    function (step) {
        return step instanceof ElementTourStep;
    };
    Object.defineProperty(TelemachyTourComponent.prototype, "progress", {
        get: /**
         * @return {?}
         */
        function () {
            return this.TelemachyService.progress;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TelemachyTourComponent.prototype, "total", {
        get: /**
         * @return {?}
         */
        function () {
            return this.TelemachyService.total;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TelemachyTourComponent.prototype, "documentWidth", {
        get: /**
         * @return {?}
         */
        function () {
            return document.body.scrollWidth + 'px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TelemachyTourComponent.prototype, "documentHeight", {
        get: /**
         * @return {?}
         */
        function () {
            return document.body.scrollHeight + 'px';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    TelemachyTourComponent.prototype.getVideoUrl = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var video = (/** @type {?} */ (this.step)).video;
        if (this.cachedVideoId === video) {
            return this.cachedVideoResource;
        }
        this.cachedVideoId = video;
        this.cachedVideoResource = this.DomSanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + video + '?rel=0');
        return this.cachedVideoResource;
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    TelemachyTourComponent.prototype.onKey = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        if ($event.key === "ArrowRight") {
            this.next();
        }
        else if ($event.key === "ArrowLeft") {
            this.previous();
        }
    };
    /**
     * @param {?} val
     * @return {?}
     */
    TelemachyTourComponent.prototype.asHtmlTourStep = /**
     * @param {?} val
     * @return {?}
     */
    function (val) {
        return /** @type {?} */ (val);
    };
    /**
     * @param {?} val
     * @return {?}
     */
    TelemachyTourComponent.prototype.asElementTourStep = /**
     * @param {?} val
     * @return {?}
     */
    function (val) {
        return /** @type {?} */ (val);
    };
    TelemachyTourComponent.decorators = [
        { type: Component, args: [{
                    selector: 'telemachy-tour',
                    template: "<div (window:keyup)=\"onKey($event)\"></div>\r\n<ng-container *ngIf=\"step\">\r\n\t<ng-container *ngIf=\"isYoutube(step)\">\r\n\t\t<div class=\"overlay\" [ngStyle]=\"{top: 0, left:0, width: '100%', height: '100vh', position: 'fixed'}\"></div>\r\n\t\t<iframe width=\"853\" height=\"480\" [src]=\"getVideoUrl()\" frameborder=\"0\" allowfullscreen class=\"video\"></iframe>\r\n\t\t<div class=\"ytpopup\">\r\n\t\t\t<div class=\"content\">\r\n\t\t\t\t<div class=\"controls\">\r\n\t\t\t\t\t<a *ngIf=\"canGoBack()\" (click)=\"previous()\">&larr;</a>\r\n\t\t\t\t\t<a *ngIf=\"!canFinish()\" (click)=\"next()\">&rarr;</a>\r\n\t\t\t\t\t<a *ngIf=\"!canFinish()\" (click)=\"skip()\">skip</a>\r\n\t\t\t\t\t<a *ngIf=\"canFinish()\" (click)=\"finish()\">finish</a>\r\n\t\t\t\t\t<span>({{progress}}/{{total}})</span>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</ng-container>\r\n\t<ng-container *ngIf=\"isHtml(step)\">\r\n\t\t<div class=\"overlay\" [ngStyle]=\"{top: 0, left:0, width: '100%', height: documentHeight, position: 'fixed'}\"></div>\r\n\t\t<div class=\"popup\">\r\n\t\t\t<div class=\"content\">\r\n\t\t\t\t<div [innerHtml]=\"asHtmlTourStep(step).body\" class=\"body\"></div>\r\n\t\t\t\t<div class=\"controls\">\r\n\t\t\t\t\t<a *ngIf=\"canGoBack()\" (click)=\"previous()\">&larr;</a>\r\n\t\t\t\t\t<a *ngIf=\"!canFinish()\" (click)=\"next()\">&rarr;</a>\r\n\t\t\t\t\t<a *ngIf=\"!canFinish()\" (click)=\"skip()\">skip</a>\r\n\t\t\t\t\t<a *ngIf=\"canFinish()\" (click)=\"finish()\">finish</a>\r\n\t\t\t\t\t<span>({{progress}}/{{total}})</span>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</ng-container>\r\n\t<ng-container *ngIf=\"isElement(step)\">\r\n\t\t<div class=\"overlay\" [ngStyle]=\"{left: 0, top: 0, width: asElementTourStep(step).documentWidth, height: asElementTourStep(step).top}\"></div>\r\n\t\t<div class=\"overlay\" [ngStyle]=\"{left: 0, top: asElementTourStep(step).top, width: asElementTourStep(step).left, height: asElementTourStep(step).fromTop}\"></div>\r\n\t\t<div class=\"overlay\" [ngStyle]=\"{left: asElementTourStep(step).left, top: asElementTourStep(step).bottom, width: asElementTourStep(step).fromLeft, height: asElementTourStep(step).toBottom}\"></div>\r\n\t\t<div class=\"overlay\" [ngStyle]=\"{left: asElementTourStep(step).right, top: asElementTourStep(step).top, width: asElementTourStep(step).toRight, height: asElementTourStep(step).height}\"></div>\r\n\r\n\t\t<div class=\"explanation\" [ngStyle]=\"{left: asElementTourStep(step).left, top: asElementTourStep(step).bottom, width: (asElementTourStep(step).domElement.getBoundingClientRect().width - 2) + 'px'}\">\r\n\t\t\t<div class=\"content\">\r\n\t\t\t\t<div [innerHtml]=\"asElementTourStep(step).body\"></div>\r\n\t\t\t\t<div class=\"controls\">\r\n\t\t\t\t\t<a *ngIf=\"canGoBack()\" (click)=\"previous()\">&larr;</a>\r\n\t\t\t\t\t<a *ngIf=\"!canFinish()\" (click)=\"next()\">&rarr;</a>\r\n\t\t\t\t\t<a *ngIf=\"!canFinish()\" (click)=\"skip()\">skip</a>\r\n\t\t\t\t\t<a *ngIf=\"canFinish()\" (click)=\"finish()\">finish</a>\r\n\t\t\t\t\t<span>({{progress}}/{{total}})</span>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</ng-container>\r\n</ng-container>\r\n",
                    styles: [".overlay{position:absolute;background:rgba(0,0,0,.5);pointer-events:none;z-index:9000000;transition:.25s}.explanation{position:absolute;min-width:220px;z-index:9000000;transition:.25s;background-color:#fff;margin-top:.5em;border:1px solid;border-color:inherit}.explanation .content{padding:1em}.explanation .controls{margin-top:1em}.popup{position:fixed;width:50%;left:25%;top:35vh;height:30vh;background-color:#fff;z-index:9000000;border:1px solid;border-color:inherit}.popup .content{padding:1em;height:calc(100% - 2em);position:relative}.popup .content .body{overflow-y:auto;height:calc(100% - 29px)}.popup .controls{position:absolute;bottom:1em}.controls a{cursor:pointer;font-size:1.5em;font-weight:100;margin-left:.5em;margin-right:.5em}.controls span{margin-left:.5em;margin-right:.5em}.video{position:fixed;top:calc((100vh - 480px)/ 2);left:calc((100% - 853px)/ 2);z-index:9000000}.ytpopup{position:fixed;bottom:calc((100vh - 480px)/ 2 - 63px - 1em);left:calc((100% - 853px)/ 2);z-index:9000000;background-color:#fff;width:853px;border:1px solid;border-color:inherit}.ytpopup .content{padding:1em}"]
                }] }
    ];
    /** @nocollapse */
    TelemachyTourComponent.ctorParameters = function () { return [
        { type: TelemachyService },
        { type: DomSanitizer }
    ]; };
    return TelemachyTourComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var TOUR_PREFIX = 'telemachy_tour_';
var LocalstorageTourPersistency = /** @class */ (function (_super) {
    __extends(LocalstorageTourPersistency, _super);
    function LocalstorageTourPersistency(ls) {
        var _this = _super.call(this) || this;
        _this.ls = ls;
        return _this;
    }
    /**
     * @param {?} componentName
     * @return {?}
     */
    LocalstorageTourPersistency.prototype.shouldStart = /**
     * @param {?} componentName
     * @return {?}
     */
    function (componentName) {
        var _this = this;
        return _super.prototype.shouldStart.call(this, componentName).pipe(map(function (shouldStart) {
            return shouldStart && !_this.ls.get(_this.keyFor(componentName));
        }));
    };
    /**
     * @param {?} componentName
     * @return {?}
     */
    LocalstorageTourPersistency.prototype.finish = /**
     * @param {?} componentName
     * @return {?}
     */
    function (componentName) {
        this.ls.set(this.keyFor(componentName), 'finished');
    };
    /**
     * @param {?} componentName
     * @return {?}
     */
    LocalstorageTourPersistency.prototype.skip = /**
     * @param {?} componentName
     * @return {?}
     */
    function (componentName) {
        this.ls.set(this.keyFor(componentName), 'skipped');
    };
    /**
     * @param {?} componentName
     * @return {?}
     */
    LocalstorageTourPersistency.prototype.keyFor = /**
     * @param {?} componentName
     * @return {?}
     */
    function (componentName) {
        return TOUR_PREFIX + componentName;
    };
    LocalstorageTourPersistency.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    LocalstorageTourPersistency.ctorParameters = function () { return [
        { type: LocalStorageService }
    ]; };
    return LocalstorageTourPersistency;
}(TourPersistency));
/**
 * @param {?} LocalStorageService
 * @return {?}
 */
function LocalstorageTourPersistencyFactory(LocalStorageService$$1) {
    return new LocalstorageTourPersistency(LocalStorageService$$1);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TelemachyModule = /** @class */ (function () {
    function TelemachyModule() {
    }
    TelemachyModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    providers: [TourPersistency, TelemachyService],
                    declarations: [TelemachyTourComponent],
                    exports: [TelemachyTourComponent]
                },] }
    ];
    return TelemachyModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { TelemachyModule, TourPersistency, LocalstorageTourPersistency, LocalstorageTourPersistencyFactory, TourStep, ElementTourStep, HTMLTourStep, YoutubeTourStep, TelemachyService, TelemachyTourComponent };

//# sourceMappingURL=telemachy.js.map
